import client1 from "../assets/images/client1.png";
import client2 from "../assets/images/client2.png";
import client3 from "../assets/images/client3.png";

function Clients() {
  return (
    <section className="animation-2 text-center max-md:p-6 my-11 p-10 px-14 max-lg:my-9 w-[60%] m-auto ">
      <h2 className="text-[48px] max-sm:text-[30px] font-bold text-yellow mb-14">
        My Clients
      </h2>
      <div className="flex justify-between items-center gap-7 max-lg:block">
        <article className=" max-lg:my-5  p-3 py-5 flex flex-col items-center justify-center gap-2 rounded-xl ">
          <img src={client1} alt="client logo" />
        </article>
        <article className=" max-lg:my-5  p-3 py-5 flex flex-col items-center justify-center gap-2 rounded-xl ">
          <img src={client2} alt="client logo" />
        </article>
        <article className=" max-lg:my-5  p-3 py-5 flex flex-col items-center justify-center gap-2 rounded-xl ">
          <img src={client3} alt="client logo" />
        </article>
      </div>
    </section>
  );
}

export default Clients;
